import lavenstein from 'js-levenshtein';

const findMatch = (header, fields, autoMapDistance) => {
    const smallestValue = fields.reduce((acc, field) => {
        const distance = Math.min(...[
            lavenstein(field.key, header),
            ...(field.alternateMatches?.map((alternate) => lavenstein(alternate, header)) || []),
        ]);
        return distance < acc.distance || acc.distance === undefined
            ? { value: field.key, distance }
            : acc;
    }, {});
    // If we have short or empty headers, only map it if there is an exact match.
    // Else it will just find the closest and match on that which can throw off results.
    if (header.length <= 2) {
        return smallestValue.distance <= 0 ? smallestValue.value : undefined;
    }
    return smallestValue.distance <= autoMapDistance ? smallestValue.value : undefined;
};

export { findMatch };
